import 'assets/scss/components/optiontile.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useState, useContext } from 'react';
import * as API from 'api/Service.js'
import { EmbedSiteShortContext } from 'App.js';
import { useErrorBoundary } from "react-error-boundary";

export default function UpsellItem({ product })
{

    const site = useContext(EmbedSiteShortContext);

    const noImageUrl = "https://chillblast-static.myshopblocks.com/default_images/default_no_image.png";
    let imageUrlParams = "?width=256&height=256&scale=canvas";

    // Handle option spec fetch
    let [productSpecModel, setProductSpecModel] = useState(null);
    let url = "/product/details?productCode=" + product.productCode;
    const fetchProductSpecRefetch = API.useRefetchQuery("fetchProductSpecRefetch" + product.productCode, url, 1);

    const { showBoundary } = useErrorBoundary();

    const handleInfoClicked = (e) =>
    {
        e.stopPropagation();

        fetchProductSpecRefetch()
            .then((response) =>
            {
                if (response?.data?.errors && Object.keys(response.data.errors).length > 0)
                {
                    throw new Error(JSON.stringify(response));
                }

                return response.data;
            })
            .then((refetchData) =>
            {
                setProductSpecModel(refetchData);
                return true; // call finished
            })
            .catch((error) =>
            {
                //console.log("OptionTile fetchProductSpecRefetch error: ", JSON.parse(JSON.stringify(error)));
                showBoundary(error);
            });
    }

    //#region Event Handlers

    const handleAddToBag = (productID = 0) =>
    {

        if (productID !== 0)
            window.CclAddToBasket(productID, null, false, process.env.NODE_ENV, true, null, 0, 0);

    }

    const handleRemoveFromBag = (productID = 0) =>
    {

        if (productID !== 0)
            window.CclRemoveFromBasket(productID, process.env.NODE_ENV, true);

    }

    //#endregion Event Handlers

    return (
        <>
            <div className="card product-card rounded-0 h-100">
                <div>
                    <span className="product-tag-container px-3" style={{ backgroundColor: product.tagColour }}>
                        {product.tagText ? <label className="product-tag mb-0" style={{ backgroundColor: product.tagColour }}>{product.tagText}</label> : null}
                    </span>
                    <img src={!product.imageUrl ? noImageUrl : (product.imageUrl + imageUrlParams)} alt={product.title} className="main-prebuilt-image w-100 h-100 p-4"></img>
                </div>
                <div className="card-body d-flex flex-column">
                    <h3 className="card-title mb-2 text-black custom-color-light">{product.title}</h3>
                    {
                        (product.salePrice && product.isOnSale)
                            ?
                            <p className="card-text text-black mb-3 custom-color-light">&pound;{product.salePrice.toFixed(2)}</p>
                            :
                            <p className="card-text text-black mb-3 custom-color-light">&pound;{product.grossPrice.toFixed(2)}</p>
                    }
                    <div className="d-flex flex-wrap my-auto">
                        {
                            product.pips
                                ?
                                product.pips.map((pip) =>
                                    <span key={"pip_" + pip.text} className="pip me-3 mb-2" style={{ backgroundColor: pip.colour }}>{pip.text}</span>
                                )
                                :
                                null
                        }
                    </div>
                    <div className="d-flex mt-3 gap-3 ">

                        <button id={"upsellProductBuy_" + product.productID} type="button" className="add-button primary-button flex-fill p-2" onClick={() => { handleAddToBag(product.productID) }}>

                            <div id={"upsellProductBuyLoading_" + product.productID} className="d-none justify-content-center align-items-center" role="status" style={{ "height": "1.2rem" }}>
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Adding...</span>
                                </div>
                            </div>

                            <span className="d-block custom-color-dark" id={"upsellProductBuyReady_" + product.productID}>ADD</span>

                        </button>

                        <button id={"upsellProductRemove_" + product.productID} type="button" className="d-none add-button white-button flex-fill p-2 d-none">

                            ADDED!

                        </button>

                        <span className="position-relative text-end align-self-center">
                            <button className="position-relative bg-transparent border-0" type="button"
                                data-bs-toggle="offcanvas"
                                data-bs-target={"#offcanvasProduct_" + product.productID}
                                aria-controls={"#offcanvasProduct_" + product.productID}
                                onClick={handleInfoClicked}
                            >
                                <FontAwesomeIcon icon={icon({ name: 'circle-info', style: 'solid' })} size="lg" />
                            </button>
                        </span>

                    </div>

                </div>

            </div>

            <div className="offcanvas offcanvas-end" tabIndex="-1" id={"offcanvasProduct_" + product.productID} aria-labelledby={"offcanvasProductLabel_" + product.productID} >

                <div className="offcanvas-header p-3 pb-2 p-md-5 pb-md-3">
                    <div>
                        <h1 className="offcanvas-title mb-2 me-2 me-sm-3 custom-color-light" id={"offcanvasProductLabel_" + product.productID}>{product.title}</h1>
                        {
                            (product.salePrice && product.isOnSale)
                                ?
                                <h4 className="text-muted fw-light mb-0">&pound;{product.salePrice.toFixed(2)}</h4>
                                :
                                <h4 className="text-muted fw-light mb-0">&pound;{product.grossPrice.toFixed(2)}</h4>
                        }
                    </div>
                    <button type="button" className="offcanvas-close-button btn-close me-1" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>

                <div className="offcanvas-body d-flex flex-column pt-2 px-3 px-md-5 pb-5">

                    {
                        product.description
                            ?
                            <p className="offcanvas-product-description mb-3">
                                {product.description}
                            </p>
                            :
                            null
                    }

                    <img src={product.imageUrl} alt={product.title} className="offcanvas-product-image w-100 mb-2 mx-auto"></img>

                    <button id={"upsellProductBuySidebar_" + product.productID} className="atb-button primary-button px-5 mt-4 mx-auto w-100 text-casing custom-color-dark" data-bs-dismiss="offcanvas"
                        type="button"
                        onClick={() => { handleAddToBag(product.productID) }}
                    >Add to Basket</button>

                    <div className="d-flex flex-column mt-3">

                        {
                            (productSpecModel !== null && productSpecModel.specifications && productSpecModel.specifications.length > 0)
                            &&
                            productSpecModel.specifications.map((spec, index) =>
                                <div key={"spanOffcanvasAttributeContainer_" + index} className="mb-3">
                                    <span key={"spanOffcanvasSpecName_" + index} className="offcanvas-attribute-text">{spec.name}: </span>
                                    <div key={"spanOffcanvasSpecValue_" + index} className="offcanvas-attribute-text fw-bold" dangerouslySetInnerHTML={{ __html: spec.value }}></div>
                                </div>
                            )
                        }
                        {/*{ /* same as above, but uses specs list on product object */}
                        {/*{*/}
                        {/*    (product.specifications && product.specifications.length > 0)*/}
                        {/*    &&*/}
                        {/*    product.specifications.map((spec, index) =>*/}
                        {/*        <div key={"spanOffcanvasAttributeContainer_" + index} className="mb-3">*/}
                        {/*            <span key={"spanOffcanvasSpecName_" + index} className="offcanvas-attribute-text">{spec.name}: </span>*/}
                        {/*            <div key={"spanOffcanvasSpecValue_" + index} className="offcanvas-attribute-text fw-bold" dangerouslySetInnerHTML={{ __html: spec.value }}></div>*/}
                        {/*        </div>*/}
                        {/*    )*/}
                        {/*}*/}

                    </div>

                </div>

            </div>

        </>
    );

}
